export const changeLoadingStatus = function (app, info) {
    app.$store.dispatch("changeLoading", info);
}